import React, { PureComponent } from 'react';
import Icon from 'style/fonts/glyphmaps/icon.component';

class Input extends PureComponent {
  render() {
    const { iconProps, inputProps, autoFocus } = this.props;
    return (
      <span className="component-input flex-row justify-between align-stretch">
        <input {...inputProps} autoFocus={autoFocus} />
        {iconProps && <Icon {...iconProps} style={{ alignSelf: 'center' }} />}
      </span>
    );
  }
}

export default Input;
